import store from '@store/redux.store';
import { settingApi } from "@/api";
import { MAX_TWO_FACTOR_SETTING_KEYS, SETTINGS_TYPES } from "@/constant";
import { actionSetItemSetting, actionSetStatus, changeSettings } from '@store/settings-reducer';
import { getCorrectFilePath } from '@/helpers/new/getCorrectFilePath';
import {
    notifyPlatformThemeColorsChange,
    PLATFORM_THEME_COLORS_SETTING_KEY,
} from '@/helpers/themeCustomization';

export const checkSettingsStore = (forceUpdate = false) => {
    return new Promise((resolve, reject) => {
        if (store.getState().settings.status && !forceUpdate) {
            resolve();
        } else {
            fethSettingsStore()
                .then(() => resolve())
                .catch((error) => reject(error));
        }
    })
}

const otherSettingsKeys = [
    'titleLoginPage',
    'subTitleLoginPage',
    'imageLoginPage',
    'catalogLogo'
];

const isMaxTwoFactorSetting = (item) =>
    MAX_TWO_FACTOR_SETTING_KEYS.includes(item?.key);

const buildGeneralSettings = (settings) => {
    const generalSettings = {};

    settings
        .filter(item => item.type !== SETTINGS_TYPES.GENERAL && isMaxTwoFactorSetting(item))
        .forEach(item => Object.assign(generalSettings, { [item.key]: item.value }));

    settings
        .filter(item => item.type === SETTINGS_TYPES.GENERAL)
        .forEach(item => Object.assign(generalSettings, { [item.key]: item.value }));

    return generalSettings;
};

export const fethSettingsStore = () => {
    return new Promise((resolve, reject) => {
        store.dispatch(actionSetStatus(1));
        settingApi.getAll()
            .then(response => {
                const settings = response.data;
                if (!settings) {
                    store.dispatch(actionSetStatus(0));
                    reject(response);
                    return;
                }
                const generalSettings = buildGeneralSettings(settings);
                localStorage.setItem(SETTINGS_TYPES.GENERAL, JSON.stringify(generalSettings));
                store.dispatch(changeSettings(generalSettings));
                const itemsCustom = settings.filter(item => item.type === SETTINGS_TYPES.CUSTOM);
                const customSettings = {};
                itemsCustom.forEach(item => Object.assign(customSettings, { [item.key]: item.value }));
                localStorage.setItem(SETTINGS_TYPES.CUSTOM, JSON.stringify(customSettings));
                store.dispatch(actionSetItemSetting('custom', customSettings));
                notifyPlatformThemeColorsChange(customSettings[PLATFORM_THEME_COLORS_SETTING_KEY]);

                const itemsPaumentSystem = settings.filter(item => item.type === SETTINGS_TYPES.PAYMENT);
                const paumentSystemSettings = {};
                itemsPaumentSystem.forEach(item => Object.assign(paumentSystemSettings, { [item.key]: item.value }));
                store.dispatch(actionSetItemSetting('paymentSystem', paumentSystemSettings));

                const authPageSettingsItems = settings.filter(item => otherSettingsKeys.includes(item.key));
                const authPageSettings = {};
                authPageSettingsItems.forEach(item => Object.assign(authPageSettings, { [item.key]: item.value }));
                store.dispatch(changeSettings(authPageSettings));
                const authImage = settings.find(item => item.key === 'authImage');
                if (authImage){
                    const authImagePath = getCorrectFilePath(authImage.value);
                    const authImageUrl = authImagePath
                        ? authImagePath.replace(/\/\/v1\//g, '/v1/')
                        : null; // заменяет //v1/ на /v1/
                    store.dispatch(actionSetItemSetting('imageLoginPage', authImageUrl));
                }
                store.dispatch(actionSetStatus(2));
                resolve();
            })
            .catch((error) => {
                store.dispatch(actionSetStatus(0));
                reject(error);
            })
    });
}
